var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQUlEQVR42mMYBZggJSX5/5w5s7FikBxBA0AKWVlZsWKYHDEGYNgOkiPbAJjYEDMAxMYViJREI2EDYDbjw8Ms6QMAR1CcR+RjZRkAAAAASUVORK5CYII=";
  export default img;